import {
  HANDOVER_SESSION_KEY,
  LOGOUT_TIMER_START_KEY,
} from "../generator/utils/refreshLogoutTimer";

/**
 * Redirect to login after session expiry.
 * In Electron (file://) assign("/") navigates to file:/// and crashes the app.
 */
export const redirectToLogin = () => {
  localStorage.removeItem("authData");
  localStorage.removeItem(LOGOUT_TIMER_START_KEY);
  localStorage.removeItem(HANDOVER_SESSION_KEY);

  if (window.location.protocol === "file:") {
    window.location.hash = "#/login";
    return;
  }

  window.location.assign("/");
};
